export const sendMessageRoute = `https://api-inference.huggingface.co/models/metaloopa/DialoGPT-medium-Rintaro`;
